import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export default async (data) => {
  try {
    const group = Entities.GroupsStore.activeGroup;
    const draft = await messageModel.getDraft(data);

    const chatDraft = new ChatMessage(draft, group.messagesStore);

    return chatDraft || null;
  } catch (error) {
    return null;
  }
};
